<template>
  <div>
    <b-loading :active="loading"></b-loading>
    <div v-if="!loading">
      <section style="position: relative" class="has-padding-30">
        <div
          style="
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: white;
          "
        ></div>
        <div
          class="has-padding-top-60"
          style="max-width: 700px; position: relative; z-index: 2"
        >
          <div class="columns">
            <div class="column has-text-centered-mobile is-3-desktop">
              <img :src="thumbnail(titleImage)" />
            </div>
            <div class="column is-9-desktop">
              <h1 class="title">
                {{ item.title }}
                {{
                  item.media_type === 'series' &&
                  item.mediadata &&
                  item.mediadata.seriesNo
                    ? `S${item.mediadata.seriesNo}`
                    : ''
                }}
              </h1>
              <p class="has-margin-bottom-15">
                <span
                  v-if="item.media_type"
                  class="has-text-weight-bold has-padding-5 has-margin-right-15"
                  >{{ item.media_type | capitalize }}</span
                >
                <span
                  v-if="year"
                  class="has-text-weight-bold has-padding-5 has-margin-right-15"
                  >{{ year }}</span
                >
                <span
                  v-if="mediaLength"
                  class="has-text-weight-bold has-padding-5 has-margin-right-15"
                  >{{ mediaLength }}</span
                >
                <span
                  v-if="ageRestriction"
                  class="has-padding-5 has-margin-right-15"
                  style="border: 1px solid #999"
                  >{{ ageRestriction }}</span
                >
                <span class="has-text-weight-bold has-padding-5"></span>
              </p>
              <p class="has-margin-bottom-15">{{ item.description }}</p>
            </div>
          </div>
          <template v-for="meta in metaToDisplay">
            <p
              v-if="item[meta.type] && item[meta.type].length > 0"
              :key="meta.type"
              class="has-margin-bottom-15"
            >
              <strong class="has-margin-right-10">{{ meta.label }}:</strong>
              <router-link
                v-for="metaItem in item[meta.type]"
                :key="metaItem.id"
                :to="{
                  name: 'Metadata',
                  params: { type: metaItem.type, id: metaItem.id },
                }"
                class="has-margin-right-5"
              >
                <b-tag type="is-primary">{{ metaItem.value }}</b-tag>
              </router-link>
            </p>
          </template>
          <div class="has-margin-top-30">
            <b-button
              class="has-margin-right-10"
              @click="
                $router.push({ name: 'MediaDetail', params: { id: item.id } })
                $parent.close()
              "
            >
              More Info
            </b-button>
            <b-button
              v-if="item.mediadata && item.mediadata.trailerVideo"
              type="is-primary"
              icon-left="play-circle-outline"
              class="has-margin-right-10"
              @click="watchTrailer()"
            >
              Trailer
            </b-button>
            <b-button
              v-if="item.mediadata && item.mediadata.screenerVideo"
              type="is-primary"
              icon-left="play-circle-outline"
              class="has-margin-right-10"
              @click="watchScreener()"
            >
              Screener
            </b-button>
            <b-button icon-left="plus-circle-outline" @click="addToCart()">
              Add to List
            </b-button>
          </div>
        </div>
      </section>
    </div>
    <LoggedInModal
      :show="showLoggedInModal"
      :redirect-url="$route.path"
      @close-modal="showLoggedInModal = false"
      @login-redirect="loginRedirect"
    ></LoggedInModal>
    <VideoModal
      :show="showModal"
      :video-id="videoId"
      @close-modal="showModal = false"
    ></VideoModal>
    <AddToCartModal
      v-if="showAddToCartModal"
      :item="item"
      :show="showAddToCartModal"
      @close-modal="showAddToCartModal = false"
    ></AddToCartModal>
  </div>
</template>

<script>
import VideoModal from '@/components/VideoModal'
import AddToCartModal from '@/components/AddToCartModal'
import LoggedInModal from '@/components/LoggedInModal'
import MediaApi from '@/api/media'
import Filters from '@/mixins/filters'
import Utils from '@/mixins/utils'
import { mapGetters } from 'vuex'

export default {
  name: 'MediaDetailModal',
  components: {
    VideoModal,
    AddToCartModal,
    LoggedInModal,
  },
  mixins: [Filters, Utils],
  props: {
    id: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      loading: true,
      item: {},
      showModal: false,
      showAddToCartModal: false,
      showLoggedInModal: false,
      videoId: '',
      metaToDisplay: [
        { type: 'right', label: 'Rights' },
        { type: 'distribution', label: 'Distribution Rights' },
        { type: 'country', label: 'Country Rights' },
      ],
    }
  },
  computed: {
    ...mapGetters(['isAuthenticated']),
    year() {
      if (
        this.item.mediadata &&
        this.item.mediadata.releaseDate &&
        this.item.mediadata.releaseDate !== ''
      ) {
        return new Date(this.item.mediadata.releaseDate).getFullYear()
      }
      return null
    },
    ageRestriction() {
      if (
        this.item.mediadata &&
        this.item.mediadata.ageRestriction &&
        this.item.mediadata.ageRestriction !== ''
      ) {
        return this.item.mediadata.ageRestriction
      }
      return null
    },
    featuredImage() {
      if (
        this.item.mediadata &&
        this.item.mediadata.featuredImage &&
        this.item.mediadata.featuredImage !== ''
      ) {
        return `url('${this.item.mediadata.featuredImage}')`
      }
      return null
    },
    titleImage() {
      if (
        this.item.mediadata &&
        this.item.mediadata.titleImage &&
        this.item.mediadata.titleImage !== ''
      ) {
        return this.item.mediadata.titleImage
      }
      return null
    },
    mediaLength() {
      if (
        this.item.media_type === 'movie' &&
        this.item.mediadata &&
        this.item.mediadata.mediaLength
      ) {
        return `${this.item.mediadata.mediaLength} mins`
      } else if (
        this.item.media_type === 'series' &&
        this.item.mediadata &&
        this.item.mediadata.noOfEpisodes
      ) {
        return `${this.item.mediadata.noOfEpisodes} episodes`
      }
      return null
    },
  },
  mounted() {
    this.fetchData(this.id)
  },
  methods: {
    getMetadata(metadata, type) {
      return metadata
        .filter((item) => item.metadata_type === type)
        .map((item) => ({
          id: item.metadata_id,
          type: item.metadata_type,
          value: item.value,
        }))
    },
    loginRedirect() {
      this.showLoggedInModal = false
      this.$emit('close')
    },
    fetchData(id) {
      MediaApi.getById(id).then((response) => {
        this.item = response
        this.item.mediadata = JSON.parse(this.item.mediadata)
        if (this.item.mediaMetadata.length > 0) {
          this.metaToDisplay.forEach((meta) => {
            this.item[meta.type] = this.getMetadata(
              this.item.mediaMetadata,
              meta.type
            )
          })
        }
        this.loading = false
      })
    },
    // getMetadata(metadata, type) {
    //   return metadata
    //     .filter(item => item.metadata_type === type)
    //     .map(item => ({ id: item.metadata_id, value: item.value }))
    // },
    watchTrailer() {
      this.videoId = this.item.mediadata.trailerVideo
      this.showModal = true
    },
    watchScreener() {
      this.videoId = this.item.mediadata.screenerVideo
      this.showModal = true
    },
    addToCart() {
      if (this.isAuthenticated) {
        this.showAddToCartModal = true
      } else {
        this.showLoggedInModal = true
      }
    },
  },
}
</script>
